import { Avatar as AvatarMui, Box, styled } from '@mui/material';
import React, { Fragment } from 'react';
import { stringName } from 'utils/functions';

const AvatarWrapper = styled(Box)(({ theme }) => ({
    padding: '3px',
    border: `1px solid ${theme.palette.ui.border}`,
    borderTopLeftRadius: '30px',
    borderBottomLeftRadius: '30px',
    borderRight: 'none',
}));

const Avatar = styled(AvatarMui)(({ theme, size = 40 }) => ({
    border: `1px solid ${theme.palette.ui.border}`,
    width: size,
    height: size,
}));

const AvatarUser = ({ user, hasWrapper = false }) => {
    let _avatar;
    if (!user) {
        _avatar = <Avatar sx={{ bgcolor: (theme) => theme.palette.ui.avatarBgcolor }}>A</Avatar>;
    } else if (user.images) {
        _avatar = <Avatar src={user.images} />;
    } else {
        _avatar = (
            <Avatar sx={{ bgcolor: (theme) => (user?.bgrColor ? user.bgrColor : theme.palette.ui.avatarBgcolor) }}>
                {stringName(user?.username)}
            </Avatar>
        );
    }

    return hasWrapper ? <AvatarWrapper>{_avatar}</AvatarWrapper> : <Fragment>{_avatar}</Fragment>;
};

export default AvatarUser;
